import axios from 'axios';

import { request } from '@/utils/request';

import { ContactDataType } from './ContactForm/ContactForm';

export const api = {
  authorize: (token: string | null) => axios.post('/api/verify-captcha', {
    token,
  }),
  postMail: (data: ContactDataType) => request.post('/email/', {
    ...data,
  }),
};
